// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
interface BreadcrumbPanelProps extends React.PropsWithChildren<{}> {
    breadcrumb: any[];
    displayProp: string;
    onClick: any;
    hideCurrentLevel?: boolean;
}

function processCrumbs(props: BreadcrumbPanelProps) {
    var crumbs: any[] = [];
    var hideCurrentLevel = (props.hideCurrentLevel) ? "hide" : "";
    if (props.breadcrumb.length > 0) {
        for (var i = 0; i < props.breadcrumb.length - 1; i++) {
            let crumb = props.breadcrumb[i];
            var hideLastSeparator = (props.hideCurrentLevel && (props.breadcrumb.length - 1 === i + 1)) ? "hide" : "";
            crumbs.push(<a className='crumb' onClick={() => props.onClick(crumb)} key={i}>{crumb[props.displayProp]}</a>);
            crumbs.push(<span className={`separator ${hideLastSeparator}`} key={i + .1}>&rsaquo; </span>);
        }
        crumbs.push(<span className={`crumb ${hideCurrentLevel}`} key={props.breadcrumb.length - 1}>{ props.breadcrumb[props.breadcrumb.length - 1][props.displayProp]}</span>);
    }
    return crumbs;
}

const BreadcrumbPanel = (props: BreadcrumbPanelProps) => (
    <div className='breadcrumb-panel'>
        <div className='crumbs'>
            { processCrumbs(props) }
        </div>
        <div className='panel'>
            {props.children}
        </div>
    </div>
);
export default BreadcrumbPanel;